
import { MapLocation } from '@/types/location';

export const najranDigitalMegacomScreens: MapLocation[] = [
  {
    id: 10065,
    name: "Digital Megacom Screen – Najran",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [17.559167, 44.226917],
    region: "Najran",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/fe771551-0a08-4a39-a11d-a41eb128a279.png"
    }
  },
  {
    id: 10066,
    name: "Digital Megacom Screen – Najran 2",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [17.605306, 44.230722],
    region: "Najran",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/c7216292-8f02-4e52-bd9e-85329e8e1f88.png"
    }
  },
  {
    id: 10067,
    name: "Digital Megacom Screen – Najran 3",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [17.490278, 44.190806],
    region: "Najran",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/5b3ebc40-062a-495c-83cc-6ea5d6a0b270.png"
    }
  },
  {
    id: 10068,
    name: "Digital Megacom Screen – Najran 4",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [17.549833, 44.220556],
    region: "Najran",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/f5a5c36f-a134-4593-8ab2-783ef26b4465.png"
    }
  }
];